import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Icon
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardLabOrderListUX = (props: any) => {
    return(
      <div
        id="CardLabOrderListUX-div-0"
        style={{width: "100%", padding:"15px 10px 0"}}>
        <div
          id="CardLabOrderListUX-div-1"
          style={{display: "flex"}}>

          <div
            id="CardLabOrderListUX-div-2"
            style={{fontSize:"1.25rem", margin: "3.5px 2rem 0px 0px", fontWeight: "bold"}}>
            Lab Order List
          </div>
          <div
            className="ui form size mini"
            id="CardLabOrderListUX-div-3"
            style={{display: "flex", alignItems: "baseline"}}>

            <div
              id="CardLabOrderListUX-div-11"
              style={{marginRight: "0.5rem", fontSize: "1rem"}}>
              Date
            </div>
            <div
              id="CardLabOrderListUX-div-4"
              style={{cursor: "pointer"}}>

              <Button
                circular={true}
                color="teal"
                icon={true}
                id="CardLabOrderListUX-Button-5"
                onClick={()=>props.onChangeFilterDate?.({type: "prev"})}
                size="mini">
                <Icon
                  id="CardLabOrderListUX-Icon-6"
                  name="angle double left">
                </Icon>
              </Button>
            </div>
            <DateTextBox
              id="CardLabOrderListUX-DateTextBox-7"
              onChange={(date)=>props.onChangeFilterDate?.({date})}
              value={props.filterCreateDate}>
            </DateTextBox>
            <div
              id="CardLabOrderListUX-div-8"
              style={{cursor: "pointer", marginLeft: "0.25em"}}>

              <Button
                circular={true}
                color="teal"
                icon={true}
                id="CardLabOrderListUX-Button-9"
                onClick={()=>props.onChangeFilterDate?.({type: "next"})}
                size="mini">
                <Icon
                  id="CardLabOrderListUX-Icon-10"
                  name="angle double right">
                </Icon>
              </Button>
            </div>
          </div>
          <div
            id="CardLabOrderListUX-div-14"
            style={{flex:1}}>

          </div>
          <div
            id="CardLabOrderListUX-div-15">

            <Button
              color="green"
              id="CardLabOrderListUX-Button-16"
              onClick={props.onAddLabRequest}
              size="small">
              Add Lab Request
            </Button>
          </div>
        </div>
        <div
          id="CardLabOrderListUX-div-12"
          style={{width:"100%",marginTop: "1rem", position: "relative"}}>

          <Table
            NoDataComponent={props.noDataComponent}
            data={props.items}
            getTrProps={props.getTrProps}
            headers="Lab ID,Request Date,Type,Order Status,Detail,Careprovider,Del,Edit"
            id="CardLabOrderListUX-Table-13"
            keys="full_access_number,created,specific_type_name,order_status,detail,careprovider,del,edit"
            minRows={7}
            showPagination={false}
            style={{height: "300px"}}
            widths="110,110,^120,^80,^120,^100,80,80">
          </Table>
          <div
            id="CardLabOrderListUX-div-17">
            {props.loader}
          </div>
        </div>
      </div>
    )
}


export default CardLabOrderListUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Thu Oct 16 2025 10:24:52 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding:\"15px 10px 0\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Lab Order List"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{fontSize:\"1.25rem\", margin: \"3.5px 2rem 0px 0px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form size mini"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"baseline\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 4,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Button-5"
        },
        "onClick": {
          "type": "code",
          "value": "()=>props.onChangeFilterDate?.({type: \"prev\"})"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Icon",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Icon-6"
        },
        "name": {
          "type": "value",
          "value": "angle double left"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 7,
      "name": "DateTextBox",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-DateTextBox-7"
        },
        "onChange": {
          "type": "code",
          "value": "(date)=>props.onChangeFilterDate?.({date})"
        },
        "value": {
          "type": "code",
          "value": "props.filterCreateDate"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", marginLeft: \"0.25em\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Button",
      "parent": 8,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Button-9"
        },
        "onClick": {
          "type": "code",
          "value": "()=>props.onChangeFilterDate?.({type: \"next\"})"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Icon",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Icon-10"
        },
        "name": {
          "type": "value",
          "value": "angle double right"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\", fontSize: \"1rem\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\",marginTop: \"1rem\", position: \"relative\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 13,
      "name": "Table",
      "parent": 12,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "props.noDataComponent"
        },
        "data": {
          "type": "code",
          "value": "props.items"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "Lab ID,Request Date,Type,Order Status,Detail,Careprovider,Del,Edit"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Table-13"
        },
        "keys": {
          "type": "value",
          "value": "full_access_number,created,specific_type_name,order_status,detail,careprovider,del,edit"
        },
        "minRows": {
          "type": "code",
          "value": "7"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\"}"
        },
        "widths": {
          "type": "value",
          "value": "110,110,^120,^80,^120,^100,80,80"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "Add Lab Request"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-Button-16"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddLabRequest"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.loader"
        },
        "id": {
          "type": "value",
          "value": "CardLabOrderListUX-div-17"
        }
      },
      "seq": 17,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardLabOrderListUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
